import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import Body from "./Components/Body/Body";
import Footer from "./Components/Footer/Footer";
import ProtectedRoute from "./Components/common/ProtectedRoute";
import TermsAndConditions from "./pages/TermsAndConditions";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import PricingHistory from "./pages/PricingHistory";

function App() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Body />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/pricing-history"
            element={
              <ProtectedRoute>
                <PricingHistory />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </AuthProvider>
    </Router>
  );
}

export default App;
